import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { updateIsLoading, update_breadcrumb } from '../../redux/action';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import PageHeading from '../../components/PageHeading/PageHeading';
import Copy from '../../components/Copy/Copy';
import Filter from '../../components/Filter/Filter';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import styles from '../../components/MuiTable/muitable.module.css';
import { formatDate } from '../../config/helpers';

const rootFilter: any = [
  {
    name: 'Warning',
    id: 'Warning',
  },
  { name: 'Error', id: 'Error' },
  { name: 'Info', id: 'Info' },
  {
    name: 'Show all',
    id: 'All',
  },
];

const ApplicationLogDetails = () => {
  const dispatch = useDispatch();
  const { fileName } = useParams();
  const [flashbar, setFlashbar] = useState({
    isOpen: false,
    message: '',
    type: '',
  });
  const [fileLog, setFileLog] = useState<any>([]);
  const [logdata, setLogData] = useState<any>([]);
  const [popUp, setPopUp] = useState(false);
  const [colData, setColData] = useState({});
  const [sortOrder, setSortOrder] = useState<'ASC' | 'DESC'>('DESC');

  useEffect(() => {
    const breadcrumb = [
      { path: '/server', name: 'Server' },
      { path: `/${fileName}`, name: `${fileName}` },
    ];
    dispatch(update_breadcrumb(breadcrumb));
    getFileDetails();
  }, []);

  const getFileDetails = () => {
    const obj = {
      fileName: `log-` + fileName + '.txt',
    };
    dispatch(updateIsLoading(true));
    instance
      .get(`/app/logdata`, { params: obj })
      .then((response) => {
        if (response.status === 200) {
          setFileLog(response.data);
          setLogData(response.data);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        setFlashbar({
          ...flashbar,
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        });
        dispatch(updateIsLoading(false));
      });
  };

  const fileLogDetails = (item: any) => {
    setPopUp(true);
    setColData(item);
  };

  const filterHandler = (row: any) => {
    if (row.id === 'All') {
      setFileLog(logdata);
    } else if (row.id !== 'Info') {
      setFileLog(
        logdata
          .filter((item: any) => item['@l'] === row.id)
          .map((m: any) => {
            return m;
          })
      );
    } else {
      setFileLog(
        logdata
          .filter((item: any) => item['@l'] !== 'Error' && item['@l'] !== 'Warning')
          .map((m: any) => {
            return m;
          })
      );
    }
  };

  const sortByDate = (order: 'ASC' | 'DESC') => {
    const sortedArray = [...fileLog].sort((a, b) => {
      const dateA = new Date(a['@t']).getTime();
      const dateB = new Date(b['@t']).getTime();

      if (order === 'ASC') {
        setSortOrder('DESC');
        return dateA - dateB;
      } else {
        setSortOrder('ASC');
        return dateB - dateA;
      }
    });
    setFileLog(sortedArray);
  };
  return (
    <div className="px-2">
      <PageHeading label="Application Log" />
      <div className="bg-white p-2 rounded-sm text-sm">
        <div className="flex items-center justify-between">
          <div className={`p-1 font-bold text-[#176b87]`}>{formatDate(fileLog?.[0]?.["@t"] || null)}</div>
          <Filter
            filterHandler={filterHandler}
            rootFilter={rootFilter}
            label={'Select status'}
            heading="Select status"
          />
        </div>
        <div className="overflow-x-auto mt-2 shadow-md">
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer>
              <Table
                stickyHeader
                aria-label="sticky table"
                align="left"
                sx={{
                  '& .MuiTableCell-sizeMedium': {
                    padding: '10px 16px',
                  },
                }}
              >
                <TableHead classes={{ root: styles.tableHead }}>
                  <TableRow style={{ padding: '12px' }}>
                    <TableCell
                      onClick={() => sortByDate(sortOrder)}
                      classes={{ root: styles.tableHeadCell }}
                    >
                      Date & Time{' '}
                      <i
                        data-testid="sort-click"
                        className={`fa-solid cursor-pointer pl-2 ${
                          sortOrder === 'ASC' ? 'fa-arrow-down' : 'fa-arrow-up'
                        }`}
                      ></i>
                    </TableCell>
                    <TableCell classes={{ root: styles.tableHeadCell }} align="left">
                      Status
                    </TableCell>
                    <TableCell classes={{ root: styles.tableHeadCell }} align="left">
                      Data
                    </TableCell>
                    <TableCell
                      classes={{ root: styles.tableHeadCell }}
                      align="right"
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fileLog?.map((item: any, index: number) => (
                    <TableRow
                      key={index}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      className="p-2"
                    >
                      <TableCell
                        classes={{ root: styles.tablebody }}
                        component="th"
                        scope="row"
                      >
                        {item['@t']}
                      </TableCell>
                      <TableCell classes={{ root: styles.tablebody }} align="left">
                        {' '}
                        {item['@l'] ? item['@l'] : 'Info'}
                      </TableCell>
                      <TableCell
                        classes={{ root: styles.tablebody }}
                        onClick={() => {
                          fileLogDetails(item);
                        }}
                        align="left"
                      >
                        {JSON.stringify(item).length < 150 ? (
                          <div>{JSON.stringify(item)}</div>
                        ) : (
                          <div>
                            {JSON.stringify(item).substring(0, 150)}{' '}
                            <span className="text-blue-700 inline text-[12px] cursor-pointer">
                              ...Read more
                            </span>
                          </div>
                        )}
                      </TableCell>
                      <TableCell classes={{ root: styles.tablebody }} align="right">
                        {' '}
                        <Copy path={JSON.stringify(item)} isOpen={false} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>

        {popUp && (
          <>
            <div className="fixed z-[60] inset-0 flex items-center justify-center w-full">
              <div className="bg-white w-fit p-4 m-2 rounded-lg shadow-lg relative flex items-end justify-end flex-wrap">
                <div className="flex">
                  <pre
                    className="pb-5 break-word overflow-y-auto md:max-w-[600px] lg:max-w-[900px] max-h-[500px] max-w-[300px]"
                    style={{
                      wordWrap: 'break-word',
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    {JSON.stringify(colData, null, 2)}
                  </pre>
                  <div
                    className="absolute -top-3 flex items-center font-bold justify-center -right-2 text-white rounded-full h-6 w-6 bg-black hover:bg-red-500 cursor-pointer"
                    onClick={() => setPopUp(false)}
                  >
                    <i className="fa-solid fa-x text-[13px]"></i>
                  </div>
                </div>
                <div className="text-base">
                  <Copy path={JSON.stringify(colData)} isOpen={false} />
                </div>
              </div>
            </div>
            <div className="opacity-75 fixed inset-0 z-50 bg-[#18315380]"></div>
          </>
        )}
      </div>
    </div>
  );
};

export default ApplicationLogDetails;
